var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconStarsTrustpilot(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 129 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.178 0H0v22.4h24.178V0zM50.118 0H25.94v22.4h24.178V0zM76.31 0H52.134v22.4h24.178V0zM102.252 0H78.074v22.4h24.178V0z",
    fill: "#00B67A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M128.444 0h-24.177v22.4h24.177V0z",
    fill: "#DCDCE6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M104.267 0h12.089v22.167h-12.089V0z",
    fill: "#00B67A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.837 14.933 15.614 14l1.512 4.433-5.29-3.5zm8.563-5.6h-6.548l-2.015-5.6-2.015 5.6H3.526l5.289 3.5-2.015 5.6 5.289-3.5 3.274-2.1 5.037-3.5zM38.03 14.933 41.806 14l1.511 4.433-5.289-3.5zm8.31-5.6h-6.548l-2.015-5.6-2.014 5.6h-6.549l5.29 3.5-2.016 5.6 5.29-3.5 3.273-2.1 5.29-3.5zM64.222 14.933 68 14l1.511 4.433-5.289-3.5zm8.311-5.6h-6.548l-2.015-5.6-2.015 5.6h-6.548l5.29 3.5-1.764 5.6 5.29-3.5 3.273-2.1 5.037-3.5zM90.163 14.933 93.94 14l1.511 4.433-5.288-3.5zm8.563-5.6h-6.549l-2.014-5.6-2.015 5.6H81.6l5.288 3.5-2.014 5.6 5.289-3.5 3.274-2.1 5.289-3.5zM116.355 14.933l3.778-.933 1.511 4.433-5.289-3.5zm8.311-5.6h-6.548l-2.015-5.6-1.763 5.6h-6.548l5.289 3.5-2.015 5.6 5.289-3.5 3.274-2.1 5.037-3.5z",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconStarsTrustpilot);
export default __webpack_public_path__ + "static/media/icon_stars_trustpilot.d17869a79338100dbf82bf0b4a2c6619.svg";
export { ForwardRef as ReactComponent };